export enum StudentRouteName {
  Absences = 'Absences',
  Agenda = 'Agenda',
  AroundTheWorld = 'AroundTheWorld',
  Business = 'Business',
  Chat = 'Chat',
  News = 'News',
  NewsDetail = 'NewsDetail',
  Notes = 'Notes',
  PartnershipUniversities = 'PartnershipUniversities',
  Shop = 'Shop',
  StageAlternance = 'StageAlternance',
  StageAlternanceForm = 'StageAlternanceForm',
  StudentCampaignDetails = 'StudentCampaignDetails',
  StudentCampaignResults = 'StudentCampaignResults',
  StudentCampaigns = 'StudentCampaigns',
  StudentHome = 'StudentHome',
}

export enum EmployeeRouteName {
  // Vues internes d'une campagne, désormais pilotées par l'URL.
  AroundTheWorldManagement = 'AroundTheWorldManagement',
  AroundTheWorldManagementMap = 'AroundTheWorldManagementMap',
  CampaignDebugBoard = 'CampaignDebugBoard',
  CampaignManagement = 'CampaignManagement',
  CampaignManagementCreate = 'CampaignManagementCreate',
  CampaignManagementDestinationInfo = 'CampaignManagementDestinationInfo',
  CampaignManagementDetails = 'CampaignManagementDetails',
  CampaignManagementInfo = 'CampaignManagementInfo',
  CampaignManagementStudentInfo = 'CampaignManagementStudentInfo',
  CampaignManagementStudents = 'CampaignManagementStudents',
  CampaignManagementUniversities = 'CampaignManagementUniversities',
  CampaignManagementUniversityAgreements = 'CampaignManagementUniversityAgreements',
  CampaignParametrage = 'CampaignParametrage',
  EmployeeHome = 'EmployeeHome',
  EmployeeNews = 'EmployeeNews',
  EmployeeNewsDetail = 'EmployeeNewsDetail',
  ExpatriationEligibility = 'ExpatriationEligibility',
  MenuManagement = 'MenuManagement',
  PreviewStoryblok = 'PreviewStoryblok',
  RoomsDisponibilities = 'RoomsDisponibilities',
  RoomsPlanning = 'RoomsPlanning',
  StudentViewer = 'StudentViewer',
}

export enum CommonRoutesName {
  Business = 'Business',
  ConfigTest = 'ConfigTest',
  Home = 'Home',
  Login = 'Login',
  NotAllowed = 'NotAllowed',
  NotFound = 'NotFound',
  StoryblokPage = 'StoryblokPage',
  StoryblokSlugList = 'StoryblokSlugList',
  PartnershipUniversities = 'PartnershipUniversities',
  PreviewStoryblok = 'PreviewStoryblok',
  Settings = 'Settings',
  SearchUsers = 'SearchUsers',
  Profile = 'Profile',
  MyProfile = 'MyProfile',
}
